<div class="container-fluid glb-popup">
  <h2>{{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}"></p-toast>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right; top:-50px; background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>

  <!-- Guest info summary -->
  <div class="guest-summary" *ngIf="reservation">
    <span class="guest-summary-item"><strong>Guest:</strong> {{reservation.guestFirstName}} {{reservation.guestLastName}}</span>
    <span class="guest-summary-item"><strong>Property:</strong> {{reservation.propertyCode}}</span>
    <span class="guest-summary-item"><strong>Door Code:</strong> {{reservation.accessCodeFrontDoor || '—'}}</span>
  </div>

  <hr>

  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="countries" formControlName="toMobileCtry"
            optionLabel="name" optionValue="dial" placeholder="Country Code"></p-dropdown>
          <label>Country Code</label>
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="toMobile" id="toMobile" type="text" pInputText>
          <label for="toMobile">To Phone Number</label>
          <ng-container *ngFor="let v of validationMessages.toMobile">
            <small class="p-invalid"
              *ngIf="form1.get('toMobile').hasError(v.type) && (form1.get('toMobile').dirty || form1.get('toMobile').touched)">
              {{v.message}}
            </small>
          </ng-container>
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="smsMessage" id="smsMessage" [rows]="5" pInputTextarea style="width:100%;"></textarea>
          <label for="smsMessage">SMS Message</label>
          <ng-container *ngFor="let v of validationMessages.smsMessage">
            <small class="p-invalid"
              *ngIf="form1.get('smsMessage').hasError(v.type) && (form1.get('smsMessage').dirty || form1.get('smsMessage').touched)">
              {{v.message}}
            </small>
          </ng-container>
        </span>
        <div class="char-count">{{form1.get('smsMessage').value?.length || 0}} characters</div>
      </div>

    </div>
  </div>

  <hr>

  <div class="row m-0">
    <div class="col-lg-12">
      <div class="button-group d-flex gap-2">
        <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true" [disabled]="formLoading">Cancel</button>
        <button pButton class="btn-addt p-button" (click)="send()" [disabled]="formLoading">
          {{formLoading ? 'Sending...' : 'Send SMS'}}
        </button>
      </div>
    </div>
  </div>
</div>
